export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  detail: (state) => state.detail,
  questionnaire: (state) => state.questionnaire,
  cdd: (state) => {
    const data = state.questionnaire?.questionnaire_master_data;
    return data && data.cdd ? JSON.parse(data.cdd) : null;
  },
  edd: (state) => {
    const data = state.questionnaire?.questionnaire_master_data;
    return data && data.edd ? JSON.parse(data.edd) : null;
  },
};
